<template>
  <div id="tabsa-rails">
    <slot />
  </div>
</template>
